import { useTranslation } from "react-i18next";
import { percent } from "./periods";

/**
 * One movement figure.
 *
 * `undefined` means no comparison was asked for, which is a custom column and
 * renders nothing at all. `null` means there was nothing to divide by, which is
 * a real answer and says so.
 */
export function Movement({
  value,
  unit,
  small,
}: {
  value: number | null | undefined;
  unit?: "pt";
  small?: boolean;
}) {
  const { t } = useTranslation();
  const size = small ? "text-[11px]" : "text-[12px]";

  if (value === undefined) return <span />;
  if (value === null) {
    return <span className={`${size} text-ink-faint`}>{t("analysis.no-base", "n/a")}</span>;
  }

  const up = value > 0;
  const flat = value === 0;
  const tone = flat ? "text-ink-faint" : up ? "text-ok" : "text-risk";
  const arrow = flat ? "" : up ? "\u25b2 " : "\u25bc ";
  // The arrow already carries direction, so the figure itself is unsigned.
  // Margin moves in percentage points, not in a percent of a percent.
  const shown =
    unit === "pt" ? `${Math.abs(value).toFixed(1)} pt` : percent(Math.abs(value));

  return (
    <span className={`${size} ${tone} tabular-nums whitespace-nowrap font-medium`}>
      {`${arrow}${shown}`}
    </span>
  );
}

